import React from 'react';

import LoadIcon from '@tradera/blueprint/theme/icons2/loading.svg?jsx';

const BlockingLoader = () => {
    return (
        <div className="blocking-loader d-flex justify-content-center align-items-center">
            <LoadIcon className="icon icon-dark icon-spin" />
        </div>
    );
};

export default BlockingLoader;
